import Header from "../../../components/admin/header";
import DashboardContainer from "../../../containers/admin";
import UserTable from "../../../components/admin/usertable";
import { useState, useEffect } from "react";
import api from "../../../utils/apiConfig";

const AllUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/admin/users")
      .then((res) => setUsers(res.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <DashboardContainer>
      <Header title="All Users" />
      <div className="p-4">
        <UserTable users={users} />
      </div>
    </DashboardContainer>
  );
};

export default AllUsers;
